import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Segment, TextArea } from 'semantic-ui-react';
import { updateDescription } from './utils';

const bioTextAreaStyle = {
  padding: 0,
  marginTop: 10,
};

const mgTop10 = {
  marginTop: 10,
};

const hintStyle = {
  color: 'gray',
};

const spacerStyle = {
  width: '100%',
  height: 5,
};

class ProfileDescription extends Component {
  static propTypes = {
    influencerDetails: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      description: props.influencerDetails.description,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.influencerDetails !== this.props.influencerDetails) {
      this.setState({ description: (nextProps.influencerDetails.description || '') });
    }
  }

  handleChange = (e, v) => this.setState({ [v.name]: v.value });

  reset = () => this.setState({
    editing: false,
    description: this.props.influencerDetails.description,
  });

  handleUpdateDescription = () => {
    const influencerDetailsID = this.props.influencerDetails.id;
    const { description } = this.state;
    updateDescription(influencerDetailsID, description);
    this.setState({ editing: false });
  }

  render() {
    const { editing, description } = this.state;
    return (
      <Segment padded>
        <h3>Influencer Bio</h3>
        <div style={spacerStyle} />
        <p style={hintStyle}>This Bio will be seen, when you add this influencer to a Shortlist.</p>
        <TextArea style={!editing ? bioTextAreaStyle : mgTop10} name="description" readOnly={!editing} value={description} onChange={this.handleChange} />
        { editing ?
          <div className="flex">
            <div className="space">
              <div className="spacer small" />
              <Button size="medium" basic fluid onClick={this.reset}>Cancel</Button>
            </div>
            <div className="space">
              <div className="spacer small" />
              <Button size="medium" color="pink" fluid onClick={this.handleUpdateDescription}>Save Changes</Button>
            </div>
          </div>
          :
          <div className="flex">
            <div className="space">
              <div className="spacer small" />
              <Button size="medium" basic fluid onClick={() => this.setState({ editing: true })}>Edit Description</Button>
            </div>
          </div>
        }
      </Segment>
    );
  }
}

export default ProfileDescription;



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-profile/profile-description.js
 **/